// Major raid healing cooldowns, lorrgs-style: just the big throughput/raid CDs,
// no externals, potions, or trinkets. Keyed by spell id. A cast of any of these
// lands on the timeline's cooldown lane, coloured by class.
//
// This is the "normal" set; later it becomes per-encounter-overridable config.

export interface CooldownDef {
  name: string;
  cls: string; // class, for colour
}

export const CLASS_COLOR: Record<string, string> = {
  druid: "#ff7d0a",
  evoker: "#33937f",
  monk: "#00ff98",
  paladin: "#f48cba",
  priest: "#ffffff",
  shaman: "#0070dd",
};

export const COOLDOWNS: Record<number, CooldownDef> = {
  // Druid — Restoration
  740: { name: "Tranquility", cls: "druid" },
  197721: { name: "Flourish", cls: "druid" },
  33891: { name: "Incarnation: Tree of Life", cls: "druid" },
  391528: { name: "Convoke the Spirits", cls: "druid" },

  // Evoker — Preservation
  363534: { name: "Rewind", cls: "evoker" },
  359816: { name: "Dream Flight", cls: "evoker" },
  370960: { name: "Emerald Communion", cls: "evoker" },
  370537: { name: "Stasis", cls: "evoker" },

  // Monk — Mistweaver
  115310: { name: "Revival", cls: "monk" },
  388615: { name: "Restoral", cls: "monk" },
  322118: { name: "Invoke Yu'lon", cls: "monk" },
  325197: { name: "Invoke Chi-Ji", cls: "monk" },

  // Paladin — Holy
  31821: { name: "Aura Mastery", cls: "paladin" },
  31884: { name: "Avenging Wrath", cls: "paladin" },
  216331: { name: "Avenging Crusader", cls: "paladin" },
  200652: { name: "Tyr's Deliverance", cls: "paladin" },

  // Priest — Discipline
  62618: { name: "Power Word: Barrier", cls: "priest" },
  47536: { name: "Rapture", cls: "priest" },
  246287: { name: "Evangelism", cls: "priest" },
  271466: { name: "Luminous Barrier", cls: "priest" },

  // Priest — Holy
  64843: { name: "Divine Hymn", cls: "priest" },
  200183: { name: "Apotheosis", cls: "priest" },
  265202: { name: "Holy Word: Salvation", cls: "priest" },
  64901: { name: "Symbol of Hope", cls: "priest" },

  // Shaman — Restoration
  108280: { name: "Healing Tide Totem", cls: "shaman" },
  98008: { name: "Spirit Link Totem", cls: "shaman" },
  114052: { name: "Ascendance", cls: "shaman" },
  108281: { name: "Ancestral Guidance", cls: "shaman" },
};
